import {
  evolve, lensPath, compose, set, pathOr
} from 'ramda';
import { requestEvolve, failEvolve, successEvolve } from './reducerUtill';

export const confirmWorkhoursActions = {
  report: {
    request: 'CONFIRM_WORKHOURS_REPORT_REQUEST',
    requestCsv: 'CONFIRM_WORKHOURS_REPORT_REQUEST_CSV',
    requestCsv2: 'CONFIRM_WORKHOURS_REPORT_REQUEST_CSV_2',
    requestDirecto: 'CONFIRM_WORKHOURS_REPORT_REQUEST_DIRECTO',
    requestPersonaCsv: 'CONFIRM_WORKHOURS_REPORT_REQUEST_PERSONA_CSV',
    requestTaaviCsv: 'CONFIRM_WORKHOURS_REPORT_REQUEST_TAAVI_CSV',
    requestExcel: 'CONFIRM_WORKHOURS_REPORT_REQUEST_EXCEL',
    requestExcelV2: 'CONFIRM_WORKHOURS_REPORT_REQUEST_EXCEL_V2',
    requestAxapta: 'CONFIRM_WORKHOURS_REPORT_REQUEST_AXAPTA',
    success: 'CONFIRM_WORKHOURS_REPORT_SUCCESS',
    fail: 'CONFIRM_WORKHOURS_REPORT_FAIL'
  },
  confirmLevels: {
    request: 'CONFIRM_WORKHOURS_CONFIRM_LEVELS_REQUEST',
    success: 'CONFIRM_WORKHOURS_CONFIRM_LEVELS_SUCCESS'
  },
  confirm: {
    request: 'CONFIRM_WORKHOURS_REQUEST',
    success: 'CONFIRM_WORKHOURS_SUCCESS',
    fail: 'CONFIRM_WORKHOURS_FAIL',
    loading: 'CONFIRM_WORKHOURS_LOADING'
  },
  summedOverhours: {
    request: 'CONFIRM_WORKHOURS_SUMMED_OVERHOURS_REQUEST',
    success: 'CONFIRM_WORKHOURS_SUMMED_OVERHOURS_SUCCESS',
    fail: 'CONFIRM_WORKHOURS_SUMMED_OVERHOURS_FAIL',
    loading: 'CONFIRM_WORKHOURS_SUMMED_OVERHOURS_LOADING'
  }
};

export const requestConfirmWorkhoursReport = (params) => ({
  type: confirmWorkhoursActions.report.request,
  payload: params
});

export const requestConfirmWorkhours = (params) => ({
  type: confirmWorkhoursActions.confirm.request,
  payload: params
});

export const requestConfirmLevels = () => ({
  type: confirmWorkhoursActions.confirmLevels.request
});

export const requestConfirmWorkhoursCsv = (cacheid) => ({
  type: confirmWorkhoursActions.report.requestCsv,
  payload: cacheid
});

export const requestConfirmWorkhoursCsv2 = (cacheid) => ({
  type: confirmWorkhoursActions.report.requestCsv2,
  payload: cacheid
});

export const requestConfirmWorkhoursDirecto = (cacheid) => ({
  type: confirmWorkhoursActions.report.requestDirecto,
  payload: cacheid
});

export const requestConfirmWorkhoursAxapta = (cacheid) => ({
  type: confirmWorkhoursActions.report.requestAxapta,
  payload: cacheid
});

export const requestConfirmWorkhoursPersonaCsv = (cacheid) => ({
  type: confirmWorkhoursActions.report.requestPersonaCsv,
  payload: cacheid
});

export const requestConfirmWorkhoursTaaviCsv = (cacheid) => ({
  type: confirmWorkhoursActions.report.requestTaaviCsv,
  payload: cacheid
});

export const requestConfirmWorkhoursExcel = (responseData) => ({
  type: confirmWorkhoursActions.report.requestExcel,
  payload: responseData
});

export const requestConfirmWorkhoursExcelV2 = (responseData) => ({
  type: confirmWorkhoursActions.report.requestExcelV2,
  payload: responseData
});

export const requestMainReportSummedOverhours = (payload) => ({
  type: confirmWorkhoursActions.summedOverhours.request,
  payload
});

const initialState = {
  report: [],
  period: {}, // report period
  cacheId: null, // report id
  params: {}, // report request params (used for reload, should be removed when update after confirmation ready)
  confirmLevels: 0,
  pending: false,
  errors: [],
  workDays: [],
  totalWorkingTime: '',
  confirmationRequestPending: false,
  summedOverhours: [],
  summedOverhoursPending: false
};

const rootSelector = (state) => pathOr({}, ['confirmWorkhoursReport'], state);

export const selectConfirmWorkhoursCacheId = compose(
  pathOr(null, ['cacheId']),
  rootSelector
);

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case confirmWorkhoursActions.report.request: {
      return evolve(requestEvolve, state);
    }
    case confirmWorkhoursActions.report.fail: {
      return evolve(failEvolve(payload), state);
    }
    case confirmWorkhoursActions.report.success: {
      const {
        period,
        report,
        cacheId,
        params,
        workDays = state.workDays,
        totalWorkingTime = state.totalWorkingTime
      } = payload;
      return compose(
        evolve(successEvolve),
        set(lensPath(['report']), report),
        set(lensPath(['period']), period),
        set(lensPath(['cacheId']), cacheId),
        set(lensPath(['params']), params),
        set(lensPath(['workDays']), workDays),
        set(lensPath(['totalWorkingTime']), totalWorkingTime),
        set(lensPath(['confirmationRequestPending']), false)
      )(state);
    }
    case confirmWorkhoursActions.confirm.loading: {
      return compose(set(lensPath(['confirmationRequestPending']), payload))(state);
    }
    case confirmWorkhoursActions.summedOverhours.loading: {
      return compose(set(lensPath(['summedOverhoursPending']), true))(state);
    }
    case confirmWorkhoursActions.summedOverhours.fail: {
      return compose(set(lensPath(['summedOverhoursPending']), false))(state);
    }
    case confirmWorkhoursActions.summedOverhours.success: {
      return compose(
        set(lensPath(['summedOverhours']), payload),
        set(lensPath(['summedOverhoursPending']), false)
      )(state);
    }
    default: {
      return state;
    }
  }
};
